import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { UiMenuItem } from 'ui-components';

export const StyledQueryFilter = styled('div')(
  () => css`
    &.query-filter {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-left: 12px;
      flex-shrink: 0;
      width: auto;

      .query-filter__select {
        width: 191px;
        flex-shrink: 0;

        .MuiFormControl-root,
        .MuiInputBase-root {
          width: 100%;
        }
      }

      .MuiOutlinedInput-root {
        height: 48px;
        border-radius: 6px;
        background: #fff;

        fieldset {
          border: 1px solid #37aaaf;
          border-radius: 6px;
        }

        &:hover {
          background: #f7f8f9;

          fieldset {
            border: 1px solid #eee;
            border-radius: 6px;
          }
        }

        &.Mui-focused fieldset {
          border: 1px solid #37aaaf;
        }
      }

      .MuiSelect-select {
        padding: 8px 12px !important;
        display: flex;
        align-items: center;
      }

      .query-filter-selectbox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        gap: 8px;
        overflow: hidden;

        .query-filter-selectbox__value {
          display: flex;
          align-items: center;
          gap: 6px;
          min-width: 0;
          flex: 1;
          overflow: hidden;

          span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .query-filter-selectbox__mode-icon {
          flex-shrink: 0;

          /* در حالت باز، موضوع ساده فقط با متن نمایش داده می‌شود */
          &.is-subject-mode {
            display: none;
          }
        }

        .arrow-icon {
          flex-shrink: 0;
          transition: transform 0.2s ease;

          &.is-open {
            transform: rotate(180deg);
          }
        }
      }
    }

    .error {
      color: red;
    }
  `
);

export const StyledQueryMenuItem = styled(UiMenuItem)(
  () => css`
    &.MuiMenuItem-root {
      padding: 6px 8px !important;
      border-radius: 4px !important;
      margin: 0 !important;
      min-height: unset !important;
      font-size: 14px !important;
      line-height: 20px !important;
      color: #0c395a !important;

      &:hover {
        background-color: #f7f8f9 !important;
        color: #0c395a !important;
        border-radius: 4px !important;
      }

      &.Mui-selected {
        background-color: #199da3 !important;
        color: #fff !important;

        &:hover {
          background-color: #199da3 !important;
          color: #fff !important;
        }

        .query-menu-item__icon {
          color: #fff !important;
        }
      }

      &.is-locked-item {
        opacity: 1 !important;
        color: #9caebb !important;
        cursor: default !important;

        &:hover {
          background-color: #f7f8f9 !important;
          color: #9caebb !important;
        }

        .query-menu-item__icon,
        .query-menu-item__lock-icon {
          color: #9caebb !important;
        }
      }
    }

    .query-menu-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      gap: 8px;

      &--locked {
        pointer-events: auto;
      }
    }

    .query-menu-item__start {
      display: flex;
      align-items: center;
      gap: 6px;
      min-width: 0;
    }

    .query-menu-item__icon,
    .query-menu-item__lock-icon {
      flex-shrink: 0;
    }
  `
);
